
    import { computed, defineComponent, ref, watch } from 'vue'
    import type { Ref } from 'vue'

    import useChat from '@/hooks/useChat'
    import useStore from '@/hooks/useStore'

    export default defineComponent({
        props: {
            showButton: {
                type: Boolean,
                default: false
            }
        },
        setup (props) {

            const { handleAddMessage, isFocusTextarea, setFocusTextarea } = useChat()
            const store = useStore()
            const message: Ref<string> = ref('')
            const textarea = ref<HTMLTextAreaElement | null>(null)
            const isHovered = ref(false)

            watch(() => isFocusTextarea.value, (value) => {
                if (value) {
                    textarea.value?.focus()
                    setFocusTextarea(false)
                }
            })
            const buttonStyle = computed(() => {
                const bgColor = store.data?.bgColor || '#000000'
                return {
                    backgroundColor: hexToRgba(bgColor, 0.99)
                }
            })
            const hoverStyle = computed(() => {
                const bgColor = store.data?.bgColor || '#000000';
                return isHovered.value
                    ? { backgroundColor: hexToRgba(bgColor, 0.75) }
                    : {};
            })

            function sendMessage (): void {
                if (message.value.trim().length === 0) return

                handleAddMessage(message.value.trim())
                message.value = ''
            }

            function autoResize (): void {
                if (textarea.value) {
                    if (textarea.value.textLength < 2) {
                        textarea.value.rows = 1
                    } else {
                        while (textarea.value.scrollHeight > textarea.value.offsetHeight) {
                            textarea.value.rows += 1
                        }
                    }
                }
            }

            function hover(data: boolean) {
                isHovered.value = data
            }

            function hexToRgba(hex: any, alpha = 1) {
                let r = 0, g = 0, b = 0;
                if (hex.length === 4) {
                    r = parseInt(hex[1] + hex[1], 16);
                    g = parseInt(hex[2] + hex[2], 16);
                    b = parseInt(hex[3] + hex[3], 16);
                } else if (hex.length === 7) {
                    r = parseInt(hex[1] + hex[2], 16);
                    g = parseInt(hex[3] + hex[4], 16);
                    b = parseInt(hex[5] + hex[6], 16);
                }
                return `rgba(${r}, ${g}, ${b}, ${alpha})`;
            }
            return {
                props,
                buttonStyle,
                autoResize,
                sendMessage,
                message,
                textarea,
                store,
                hover,
                hoverStyle
            }
        }
    })

